__turbopack_context__.v({
  "list": "CommaList-module__9PaeOG__list",
});
